// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#page-default[data-v-80051d2e]{min-height:100vh}.prepared[data-v-80051d2e]{max-width:clamp(50rem,80vw + 20rem,94.5rem);margin:0 auto;padding:0 clamp(.9375rem,3.5vw,2.875rem)}.ct-hero[data-v-80051d2e]{padding:0 clamp(1.25rem,3vw,3.75rem);background:linear-gradient(180deg,hsla(0,0%,100%,0),hsla(0,0%,100%,0) 50%,#fff 0,#fff)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
